// ---------------------------------------------------------------------------
// Reviews slider (Splide)
// ---------------------------------------------------------------------------
import Splide from '@splidejs/splide';

export function initReviewsSlider() {
    const el = document.querySelector('[data-reviews-slider]');
    if (!el) return;

    new Splide(el, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: '2rem',
        pagination: true,
        arrows: false,
        autoplay: true,
        interval: 4500,
        pauseOnHover: true,
        breakpoints: {
            991.98: { perPage: 2 },
            767.98: { perPage: 1, gap: '1rem' },
        },
    }).mount();
}
